import backgroundImage from "@/assets/receiptrex-office-3to2-3000x2000-75.webp";
import PWAInstallButton from "@/components/PWAInstallButton";

export function HomePage() {
    return (
        <div
            className="relative container w-full min-h-screen mx-auto bg-cover bg-center bg-no-repeat rounded-4xl overflow-hidden"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            {/* Bottom gradient overlay */}
            <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/40 to-transparent" />

            <div className="relative z-1 flex flex-col items-center justify-end h-screen p-8 -mb-20 space-y-6">
                <div className="text-5xl font-bold text-center text-white tracking-tight leading-tight drop-shadow-lg">
                    Receiptrex
                </div>
                <div className="text-xl font-normal text-center text-white/90 leading-relaxed max-w-2xl drop-shadow-md">
                    Scan receipts, extract data automatically, and manage
                    expenses effortlessly
                </div>
                <div className="pt-4">
                    <PWAInstallButton />
                </div>
            </div>
        </div>
    );
}
